const DRM_TYPES = [
    {
        dmlsName: 'WIDEVINE',
        keySystem: 'com.widevine.alpha',
        supportedConfiguration: [
            {
                initDataTypes: ['cenc'],
                audioCapabilities: [
                    { contentType: 'audio/mp4;codecs="mp4a.40.2"', robustness: 'SW_SECURE_CRYPTO' },
                ],
                videoCapabilities: [
                    {
                        contentType: 'video/mp4; codecs="avc1.4d401f"',
                        robustness: 'SW_SECURE_DECODE',
                    },
                ],
            },
        ],
    },
    {
        dmlsName: 'PLAYREADY',
        keySystem: 'com.microsoft.playready',
        supportedConfiguration: [
            {
                initDataTypes: ['cenc'],
                audioCapabilities: [
                    { contentType: 'audio/mp4;codecs="mp4a.40.2"', robustness: 'SW_SECURE_CRYPTO' },
                ],
                videoCapabilities: [
                    {
                        contentType: 'video/mp4; codecs="avc1.4d401f"',
                        robustness: 'SW_SECURE_DECODE',
                    },
                ],
            },
        ],
    },
];
const MOBILE_DRM_TYPES = [
    {
        dmlsName: 'WIDEVINE',
        keySystem: 'com.widevine.alpha',
        supportedConfiguration: [
            {
                initDataTypes: ['cenc'],
                audioCapabilities: [
                    { contentType: 'audio/mp4;codecs="mp4a.40.2"', robustness: 'SW_SECURE_CRYPTO' },
                ],
            },
        ],
    }
];
export function getDrmType(browserName, browserVersion, osName) {
    if (osName === 'Android') {
        return MOBILE_DRM_TYPES[0];
    }
    switch (browserName) {
        case 'Chrome':
        case 'Firefox':
        case 'Opera':
        case 'Brave':
            return DRM_TYPES[0];
        case 'IE':
            return DRM_TYPES[1];
        case 'Edge':
            return +browserVersion >= 79 ? DRM_TYPES[0] : DRM_TYPES[1];
        default:
            return DRM_TYPES[0];
    }
}
